setTimeout(function () {
  try {
    const { pathname } = window.location;
    console.log("pathname:", pathname);

    const url = `https://backto890s.com${pathname}`

    if (pathname === '/' || pathname === '/cart' || pathname.startsWith('/products/')) {
      window.location.href = url
    }
  } catch (e) {
    console.error("ERROR", error);
  }
});
